// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    box-sizing: border-box;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure, 
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  a {
    text-decoration: none!important;
    color: #063922;
  }
  a:hover {
    color: #0B093B;
  }
  input:-webkit-autofill { /* Change the color to your own background color */
    box-shadow: transparent;
    -webkit-text-fill-color: #fff;
  }
  body {
    background: #fff;
    color: #063922;
    font-family: 'Khula', sans-serif;
    overflow-x: hidden;
    font-size: 16px;
    font-weight: 400;
  }
  .container {
    width: 100%;
    max-width: 1220px;
    margin: 0 auto;
    padding: 0px 30px;
  }
  @media only screen and (max-width: 859px) {
    .container {
      padding: 0 15px;
    }
  }
  .regular {
    font-weight: 400!important;
  }
  .semiBold {
    font-weight: 600!important;
  }
  .extraBold {
    font-weight: 800!important;
  }

  /* HELLPERS */
  .textCenter {
    text-align: center
  }
  .animate {
    transition: 0.3s ease;
  }
  .pointer {
    cursor: pointer;
  }
  .relative {
    position: relative;
  }
  .textCenter {
    text-align: center;
  }
  .textLeft {
    text-align: left;
  }
  .textRight {
    text-align: right;
  }
  .x100 {
    width: 100%;
  }
  .active {
    border-bottom: 2px solid #D4AF37;
    color: #D4AF37;
  }
  .tag {
    padding: 5px 10px;
    margin: 10px 0;
  }
  .shadow {
    box-shadow: 0 0 11px rgba(237, 232, 237, 0.5)  ; 
    -webkit-box-shadow: 0 0 11px rgba(237, 232, 237, 0.5)  ; 
    -moz-box-shadow: 0 0 11px rgba(237, 232, 237, 0.5)  ; 
  }
  /* FLEXBOX */
  .flex {
    display: flex;
  }
  .flexSpaceCenter {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .flexNullCenter {
    display: flex;
    align-items: center;
  }
  .flexColumn {
    flex-direction: column;
  }
  .flexCenter {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .flexSpaceNull {
    display: flex;
    justify-content: space-between;
  }

  /* FONT SIZES */
  .font11 {
    font-size: 0.688rem;
  }
  .font12 {
    font-size: 0.75rem;
  }
  .font13 {
    font-size: 0.813rem;
  }
  .font14 {
    font-size: 0.875rem;
  }
  .font15 {
    font-size: 0.938rem;
  }
  .font18 {
    font-size: 1.125rem;
  }
  .font20 {
    font-size: 1.25rem;
  }
  .font25 {
    font-size: 1.563rem;
  }
  .font30 {
    font-size: 1.875rem;
  }
  .font40 {
    font-size: 2.5rem;
  }
  .font60 {
    font-size: 3.75rem;
    line-height: 4.5rem;
  }
  @media only screen and (max-width: 859px) {
    .font11 {
      font-size: 0.688rem;
    }
    .font12 {
      font-size: 0.688rem;
    }
    .font13 {
      font-size: 0.75rem;
    }
    .font14 {
      font-size: 0.813rem;
    }
    .font15 {
      font-size: 0.813rem;
    }
    .font18 {
      font-size: 0.938rem;
    }
    .font20 {
      font-size: 1.125rem;
    }
    .font25 {
      font-size: 1.25rem;
    }
    .font30 {
      font-size: 1.5rem;
    }
    .font40 {
      font-size: 1.875rem;
    }
    .font60 {
      font-size: 2.8rem;
    }
  }
  /* BORDER RADIUS */
  .radius8 {
    border-radius: 1rem;
  }
  .radius6 {
    border-radius: 0.6rem;
  }
  /* COLORS */
  .darkColor {
    color: #063922;
  }
  .purpleColor {
    color: #D4AF37;
  }
  .orangeColor {
    color: #F2B300;
  }
  .lightColor {
    color: #F5F5F5;
  }
  .coralColor {
    color: #C4FFFF;
  }
  .greenColor {
    color: #49CB86;
  }
  .greyColor {
    color: #707070;
  }
  .whiteColor {
    color: #fff;
  }
  /* BACKGROUNDS */
  .darkBg {
    background-color: #063922;
  }
  .purpleBg {
    background-color: #D4AF37;
  }
  .orangeBg {
    background-color: #F2B300;
  }
  .lightBg {
    background-color: #F5F5F5;
  }
  .coralBg {
    background-color: #C4FFFF;
  }
  .greenBg {
    background-color: #49CB86;
  }
  .greyBg {
    background-color: #707070;
  }
  .whiteBg {
    background-color: #fff;
  }

  /* ----------------------------- */
  /* Public template dark mode     */
  /* (uses <html class="dark">)    */
  /* ----------------------------- */
  .dark body {
    background: #0b0f0e;
    color: #fff;
  }
  .dark h1,
  .dark h2,
  .dark h3,
  .dark h4,
  .dark h5,
  .dark h6 {
    color: #fff;
  }
  .dark a {
    color: #d4af37;
  }
  .dark a:hover {
    color: #f2b300;
  }
  .dark .darkColor {
    color: #fff;
  }
  .dark .greyColor {
    color: rgba(245, 245, 245, 0.7);
  }
  .dark .whiteBg {
    background-color: #0f1413;
  }
  .dark .lightBg {
    background-color: #121a18;
  }
  .dark .darkBg {
    background-color: #063922;
  }

  /* Public template logo – same asset on mobile and desktop */
  .logo-public {
    height: 32px;
    width: auto;
    display: block;
  }
  @media only screen and (min-width: 760px) {
    .logo-public {
      height: 40px;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/publicTemplate/style/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;IAaI,SAAS;IACT,UAAU;IACV,SAAS;IACT,wBAAwB;IACxB,sBAAsB;EACxB;EACA,gDAAgD;EAChD;;IAEE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;;IAEE,WAAW;IACX,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,+BAA+B;IAC/B,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA,yBAC4C,kDAAkD;IAC5F,uBAAuB;IACvB,6BAA6B;EAC/B;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,iBAAiB;EACnB;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;;EAEA,aAAa;EACb;IACE;EACF;EACA;IACE,qBAAqB;EACvB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,gCAAgC;IAChC,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,+CAA+C;IAC/C,uDAAuD;IACvD,oDAAoD;EACtD;EACA,YAAY;EACZ;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA,eAAe;EACf;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE;MACE,mBAAmB;IACrB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,mBAAmB;IACrB;IACA;MACE,iBAAiB;IACnB;EACF;EACA,kBAAkB;EAClB;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA,WAAW;EACX;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA,gBAAgB;EAChB;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;;EAEA,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC;IACE,mBAAmB;IACnB,WAAW;EACb;EACA;;;;;;IAME,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,+BAA+B;EACjC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;;EAEA,4DAA4D;EAC5D;IACE,YAAY;IACZ,WAAW;IACX,cAAc;EAChB;EACA;IACE;MACE,YAAY;IACd;EACF","sourcesContent":["html, body, div, span, applet, object, iframe,\n  h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n  a, abbr, acronym, address, big, cite, code,\n  del, dfn, em, img, ins, kbd, q, s, samp,\n  small, strike, strong, sub, sup, tt, var,\n  b, u, i, center,\n  dl, dt, dd, ol, ul, li,\n  fieldset, form, label, legend,\n  table, caption, tbody, tfoot, thead, tr, th, td,\n  article, aside, canvas, details, embed, \n  figure, figcaption, footer, header, hgroup, \n  menu, nav, output, ruby, section, summary,\n  time, mark, audio, video {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    vertical-align: baseline;\n    box-sizing: border-box;\n  }\n  /* HTML5 display-role reset for older browsers */\n  article, aside, details, figcaption, figure, \n  footer, header, hgroup, menu, nav, section {\n    display: block;\n  }\n  ol, ul {\n    list-style: none;\n  }\n  blockquote, q {\n    quotes: none;\n  }\n  blockquote:before, blockquote:after,\n  q:before, q:after {\n    content: '';\n    content: none;\n  }\n  table {\n    border-collapse: collapse;\n    border-spacing: 0;\n  }\n  a {\n    text-decoration: none!important;\n    color: #063922;\n  }\n  a:hover {\n    color: #0B093B;\n  }\n  input:-webkit-autofill {\n    -webkit-box-shadow:0 0 0 50px #fff inset; /* Change the color to your own background color */\n    box-shadow: transparent;\n    -webkit-text-fill-color: #fff;\n  }\n  body {\n    background: #fff;\n    color: #063922;\n    font-family: 'Khula', sans-serif;\n    overflow-x: hidden;\n    font-size: 16px;\n    font-weight: 400;\n  }\n  .container {\n    width: 100%;\n    max-width: 1220px;\n    margin: 0 auto;\n    padding: 0px 30px;\n  }\n  @media only screen and (max-width: 859px) {\n    .container {\n      padding: 0 15px;\n    }\n  }\n  .regular {\n    font-weight: 400!important;\n  }\n  .semiBold {\n    font-weight: 600!important;\n  }\n  .extraBold {\n    font-weight: 800!important;\n  }\n\n  /* HELLPERS */\n  .textCenter {\n    text-align: center\n  }\n  .animate {\n    transition: 0.3s ease;\n  }\n  .pointer {\n    cursor: pointer;\n  }\n  .relative {\n    position: relative;\n  }\n  .textCenter {\n    text-align: center;\n  }\n  .textLeft {\n    text-align: left;\n  }\n  .textRight {\n    text-align: right;\n  }\n  .x100 {\n    width: 100%;\n  }\n  .active {\n    border-bottom: 2px solid #D4AF37;\n    color: #D4AF37;\n  }\n  .tag {\n    padding: 5px 10px;\n    margin: 10px 0;\n  }\n  .shadow {\n    box-shadow: 0 0 11px rgba(237, 232, 237, 0.5)  ; \n    -webkit-box-shadow: 0 0 11px rgba(237, 232, 237, 0.5)  ; \n    -moz-box-shadow: 0 0 11px rgba(237, 232, 237, 0.5)  ; \n  }\n  /* FLEXBOX */\n  .flex {\n    display: flex;\n  }\n  .flexSpaceCenter {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .flexNullCenter {\n    display: flex;\n    align-items: center;\n  }\n  .flexColumn {\n    flex-direction: column;\n  }\n  .flexCenter {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .flexSpaceNull {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  /* FONT SIZES */\n  .font11 {\n    font-size: 0.688rem;\n  }\n  .font12 {\n    font-size: 0.75rem;\n  }\n  .font13 {\n    font-size: 0.813rem;\n  }\n  .font14 {\n    font-size: 0.875rem;\n  }\n  .font15 {\n    font-size: 0.938rem;\n  }\n  .font18 {\n    font-size: 1.125rem;\n  }\n  .font20 {\n    font-size: 1.25rem;\n  }\n  .font25 {\n    font-size: 1.563rem;\n  }\n  .font30 {\n    font-size: 1.875rem;\n  }\n  .font40 {\n    font-size: 2.5rem;\n  }\n  .font60 {\n    font-size: 3.75rem;\n    line-height: 4.5rem;\n  }\n  @media only screen and (max-width: 859px) {\n    .font11 {\n      font-size: 0.688rem;\n    }\n    .font12 {\n      font-size: 0.688rem;\n    }\n    .font13 {\n      font-size: 0.75rem;\n    }\n    .font14 {\n      font-size: 0.813rem;\n    }\n    .font15 {\n      font-size: 0.813rem;\n    }\n    .font18 {\n      font-size: 0.938rem;\n    }\n    .font20 {\n      font-size: 1.125rem;\n    }\n    .font25 {\n      font-size: 1.25rem;\n    }\n    .font30 {\n      font-size: 1.5rem;\n    }\n    .font40 {\n      font-size: 1.875rem;\n    }\n    .font60 {\n      font-size: 2.8rem;\n    }\n  }\n  /* BORDER RADIUS */\n  .radius8 {\n    border-radius: 1rem;\n  }\n  .radius6 {\n    border-radius: 0.6rem;\n  }\n  /* COLORS */\n  .darkColor {\n    color: #063922;\n  }\n  .purpleColor {\n    color: #D4AF37;\n  }\n  .orangeColor {\n    color: #F2B300;\n  }\n  .lightColor {\n    color: #F5F5F5;\n  }\n  .coralColor {\n    color: #C4FFFF;\n  }\n  .greenColor {\n    color: #49CB86;\n  }\n  .greyColor {\n    color: #707070;\n  }\n  .whiteColor {\n    color: #fff;\n  }\n  /* BACKGROUNDS */\n  .darkBg {\n    background-color: #063922;\n  }\n  .purpleBg {\n    background-color: #D4AF37;\n  }\n  .orangeBg {\n    background-color: #F2B300;\n  }\n  .lightBg {\n    background-color: #F5F5F5;\n  }\n  .coralBg {\n    background-color: #C4FFFF;\n  }\n  .greenBg {\n    background-color: #49CB86;\n  }\n  .greyBg {\n    background-color: #707070;\n  }\n  .whiteBg {\n    background-color: #fff;\n  }\n\n  /* ----------------------------- */\n  /* Public template dark mode     */\n  /* (uses <html class=\"dark\">)    */\n  /* ----------------------------- */\n  .dark body {\n    background: #0b0f0e;\n    color: #fff;\n  }\n  .dark h1,\n  .dark h2,\n  .dark h3,\n  .dark h4,\n  .dark h5,\n  .dark h6 {\n    color: #fff;\n  }\n  .dark a {\n    color: #d4af37;\n  }\n  .dark a:hover {\n    color: #f2b300;\n  }\n  .dark .darkColor {\n    color: #fff;\n  }\n  .dark .greyColor {\n    color: rgba(245, 245, 245, 0.7);\n  }\n  .dark .whiteBg {\n    background-color: #0f1413;\n  }\n  .dark .lightBg {\n    background-color: #121a18;\n  }\n  .dark .darkBg {\n    background-color: #063922;\n  }\n\n  /* Public template logo – same asset on mobile and desktop */\n  .logo-public {\n    height: 32px;\n    width: auto;\n    display: block;\n  }\n  @media only screen and (min-width: 760px) {\n    .logo-public {\n      height: 40px;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
